export class DocumentCategoryResultDto {
    code: string;
    name: string;
    viewInBoardPortal: boolean;
    viewInResidentPortal: boolean;
    allowToggleViewInBoardPortal: boolean;
    allowToggleViewInResidentPortal: boolean;
}
